import Select from 'react-select';
import { formatMessage } from "i18n/CurrentLocale";
import placeholders from "string-translations/placeholders";


export enum Sector {
    CONSTRUCTION_INFRASTRUCTURE = 'CONSTRUCTION_INFRASTRUCTURE',
    ENERGY_UTILITIES = 'ENERGY_UTILITIES',
    GOVERNMENT_PUBLIC_SECTOR = 'GOVERNMENT_PUBLIC_SECTOR',
    HEALTHCARE_SOCIAL_SERVICES = 'HEALTHCARE_SOCIAL_SERVICES',
    HVAC_FIELD_SERVICES = 'HVAC_FIELD_SERVICES',
    LANDSCAPING_GROUNDS_SERVICES = 'LANDSCAPING_GROUNDS_SERVICES',
    PEST_CONTROL = 'PEST_CONTROL',
    PROPERTY_FACILITIES = 'PROPERTY_FACILITIES',
    SECURITY_FIRE_PROTECTION = 'SECURITY_FIRE_PROTECTION',
    STAFFING_WORKFORCE = 'STAFFING_WORKFORCE',
    OTHER_INDUSTRIES = 'OTHER_INDUSTRIES'
}

type SectorDropdownOption = {
    value: Sector,
    label: string
}

type InputSectorProps = {
    sector: Sector,
    onChange: Function
}

export const InputSector = (props: InputSectorProps) => {

    const dropdownOptions = [
        { value: Sector.CONSTRUCTION_INFRASTRUCTURE, label: formatMessage({ id: 'INDUSTRY_CONSTRUCTION_INFRASTRUCTURE' }) },
        { value: Sector.ENERGY_UTILITIES, label: formatMessage({ id: 'INDUSTRY_ENERGY_UTILITIES' }) },
        { value: Sector.GOVERNMENT_PUBLIC_SECTOR, label: formatMessage({ id: 'INDUSTRY_GOVERNMENT_PUBLIC_SECTOR' }) },
        { value: Sector.HEALTHCARE_SOCIAL_SERVICES, label: formatMessage({ id: 'INDUSTRY_HEALTHCARE_SOCIAL_SERVICES' }) },
        { value: Sector.HVAC_FIELD_SERVICES, label: formatMessage({ id: 'INDUSTRY_HVAC_FIELD_SERVICES' }) },
        { value: Sector.LANDSCAPING_GROUNDS_SERVICES, label: formatMessage({ id: 'INDUSTRY_LANDSCAPING_GROUNDS_SERVICES' }) },
        { value: Sector.PEST_CONTROL, label: formatMessage({ id: 'INDUSTRY_PEST_CONTROL' }) },
        { value: Sector.PROPERTY_FACILITIES, label: formatMessage({ id: 'INDUSTRY_PROPERTY_FACILITIES' }) },
        { value: Sector.SECURITY_FIRE_PROTECTION, label: formatMessage({ id: 'INDUSTRY_SECURITY_FIRE_PROTECTION' }) },
        { value: Sector.STAFFING_WORKFORCE, label: formatMessage({ id: 'INDUSTRY_STAFFING_WORKFORCE' }) },
        { value: Sector.OTHER_INDUSTRIES, label: formatMessage({ id: 'INDUSTRY_OTHER_INDUSTRIES' }) }
    ];

    return (
        <Select<SectorDropdownOption, false>
            inputId="reg-sector"
            name="sector"
            value={dropdownOptions
                .filter(({ value }) => value === props.sector)
            }
            placeholder={formatMessage(placeholders.chooseIndustry)}
            onChange={(option) => props.onChange(option?.value)}
            options={dropdownOptions}
            isSearchable={false}
            className={'react-select-container react-select-with-border'}
            classNamePrefix={'react-select'}
        />
    )

}